import classNames from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';

interface ILinkAreaProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  href: string;
  preventDefault?: boolean;
  target?: React.HTMLAttributeAnchorTarget;
}

export function LinkArea({ href, target, children, preventDefault, ...divProps }: ILinkAreaProps) {
  const onLinkClick = React.useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      if (preventDefault) {
        e.preventDefault();
      }
    },
    [preventDefault],
  );

  return (
    <div {...divProps} className={classNames(styles['container'], divProps.className)}>
      <a href={href} target={target} className={styles['link']} onClick={onLinkClick} draggable={false}>
        <span className={styles['link-area']} />
      </a>
      {children}
    </div>
  );
}
